import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Notification } from "../common/Notification";
import { addDardWebMonitoringBankAccount } from "../../store/service";
import { useTranslation } from "react-i18next";

interface IProps {
    closeDialog: any;
    disableSelect: Boolean;
    showUsType: Boolean;
    supportInternational: any;
}

const DarkWebFinancialAccountAddBankDialog: React.FunctionComponent<IProps> = (props) => {
    const { register, errors, reset, formState, handleSubmit, watch, clearErrors } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
    });

    const { isSubmitting } = formState;
    const [accountNumber, setAccountNumber] = useState("");
    const [routingNumber, setRoutingNumber] = useState("");
    const [accountType, setAcountType] = useState("US");
    const [isLoading, setIsLoading] = useState(false);
    const { t: tLang, i18n: i18nLang } = useTranslation();

    useEffect(() => {
        if (props.showUsType) {
            setAcountType("Non-US");
        }
    }, []);

    useEffect(() => {
        const cancelBtn: any = document.getElementById("btn-cancel-dark-web-add-financial-acc");
        cancelBtn.addEventListener("click", () => {
            reset();
            props.closeDialog("cancel");
        });
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                reset();
                props.closeDialog("cancel");
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    const typeChanged = () => {
        setAcountType(watch("accountType"));
        clearErrors();
    };

    const accountNumberChange = (event: any): any => {
        setAccountNumber(event.currentTarget.value);
    };

    const routingNumberChange = (event: any): any => {
        setRoutingNumber(event.currentTarget.value);
    };

    const addAccount = () => {
        setIsLoading(true);
        addDardWebMonitoringBankAccount(accountNumber, routingNumber, accountType)
            .then((data) => {
                if (data.isSuccess === true) {
                    Notification({
                        type: "success",
                        title: tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.toasterMessage.addSuccess.title"),
                        message: tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.toasterMessage.addSuccess.message"),
                        duration: 0,
                    });
                    props.closeDialog("close");
                }
                else {
                    if (data && data.errors.length && data.errors[0] === "Duplicate Bank Account Number") {
                        Notification({
                            type: "error",
                            title: tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.toasterMessage.duplicateError.title"),
                            message: tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.toasterMessage.duplicateError.message"),
                            duration: 0,
                        });
                    } else if (data && data.errors.length && data.errors[0] === "Duplicate IBAN Account Number") {
                        Notification({
                            type: "error",
                            title: tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.toasterMessage.duplicateError.title"),
                            message: tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.toasterMessage.duplicateError.ibanMessage"),
                            duration: 0,
                        });
                    } else if (data && data.errors.length) {
                        Notification({
                            type: "error",
                            title: tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.toasterMessage.addError.title"),
                            message: data.errors[0],
                            duration: 0,
                        });
                    }   else {
                        Notification({
                            type: "error",
                            title: tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.toasterMessage.addError.title"),
                            message: tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.toasterMessage.addError.message"),
                            duration: 0,
                        });
                    }
                }
                setIsLoading(false);
            })
            .catch(function (error) {
                Notification({
                    type: "error",
                    title: tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.toasterMessage.addError.title"),
                    message: tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.toasterMessage.addError.message"),
                    duration: 0,
                });
                setIsLoading(false);
            });
    };

    return (
        <React.Fragment>
            <div className={`${isLoading && "loading"}`}>
                <div className="dialog-header">
                    <div className="dialog-icon status-default">
                        <em className="las la-plus"></em>
                    </div>
                    <h1>{tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.addAccountPopup.title")}</h1>
                </div>

                <div className="dialog-body">
                    <form id="form-add-dark-web-monitor-bank-account" onSubmit={handleSubmit(addAccount)}>
                        <React.Fragment>
                            {props.supportInternational && (
                                <div className="form-row row">
                                    <div className={errors["accountType"] ? "form-row status-error" : "form-row"}>
                                        <div className="form-label">
                                            <label htmlFor="accountType">
                                                {tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.addAccountPopup.label.accountType")}{" "}
                                                <span className="required" title="Mandatory">
                                                    {" "}
                                                    *{" "}
                                                </span>
                                            </label>
                                        </div>
                                        <div className="form-input">
                                            <select
                                                disabled={!Boolean(props.disableSelect) || Boolean(props.showUsType)}
                                                className="inputbox"
                                                name="accountType"
                                                ref={register}
                                                onChange={() => typeChanged()}
                                            >
                                                {!props.showUsType && (
                                                    <option value="US">
                                                        {tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.usBankAccount.title")}
                                                    </option>
                                                )}{" "}
                                                {/*US Bank Account Change to Bank Account 24672 */}
                                                {props.disableSelect && <option value="Non-US">IBAN</option>}{" "}
                                                {/*NOn us bank account change to IBAN Accounts US 24672*/}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div className="form-row row">
                                <div className={errors["accountNumber"] ? "form-row status-error" : "form-row"}>
                                    <div className="form-label">
                                        <label htmlFor="accountNumber">
                                            {tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.addAccountPopup.label.accountNumber")}{" "}
                                            <span className="required" title="Mandatory">
                                                {" "}
                                                *{" "}
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input">
                                        <input
                                            aria-required="true"
                                            ref={register({ required: true, pattern: accountType == "Non-US" ? /^$|^([a-z0-9A-Z]{4,33})$/ : /^$|^(\d{4,33})$/ })}
                                            type="text"
                                            name="accountNumber"
                                            className="inputbox"
                                            id="accountNumber"
                                            maxLength={33}
                                            onBlur={(e) => accountNumberChange(e)}
                                        />
                                        {{ ...errors["accountNumber"] }.type === "required" && (
                                            <span aria-required="true" className="form-error">
                                                {tLang(
                                                    "identityVault.monitoredInformation.financialAccountWidget.bankAccount.addAccountPopup.validationMessage.accountNumberRequired"
                                                )}
                                            </span>
                                        )}

                                        {{ ...errors["accountNumber"] }.type === "pattern" && accountType === "US" && (
                                            <span aria-required="true" className="form-error">
                                                {tLang(
                                                    "identityVault.monitoredInformation.financialAccountWidget.bankAccount.addAccountPopup.validationMessage.accountNumberPattern"
                                                )}
                                            </span>
                                        )}
                                        {{ ...errors["accountNumber"] }.type === "pattern" && accountType === "Non-US" && (
                                            <span className="form-error">
                                                {tLang(
                                                    "identityVault.monitoredInformation.financialAccountWidget.bankAccount.addAccountPopup.validationMessage.IBANNumberPattern"
                                                )}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                         {/* remove routing number for add bank account under this feature https://dev.azure.com/ezsdev/Development/_workitems/edit/45813 */}
                        {/*     {accountType === "US" && (
                                <div className="form-row row">
                                    <div className={errors["routingNumber"] ? "form-row status-error" : "form-row"}>
                                        <div className="form-label">
                                            <label htmlFor="routingNumber">
                                                {tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.addAccountPopup.label.routingNumber")}{" "}
                                                <span className="required" title="Mandatory">
                                                    {" "}
                                                    *{" "}
                                                </span>
                                            </label>
                                        </div>
                                        <div role="alert" className="form-input">
                                            <input
                                                aria-required="true"
                                                ref={register({ required: true, pattern: /^(\d{9})|$^[0-9]*$/ })}
                                                type="text"
                                                name="routingNumber"
                                                className="inputbox"
                                                id="routingNumber"
                                                maxLength={9}
                                                onBlur={(e) => routingNumberChange(e)}
                                            />
                                            {{ ...errors["routingNumber"] }.type === "required" && (
                                                <span aria-required="true" className="form-error">
                                                    {tLang(
                                                        "identityVault.monitoredInformation.financialAccountWidget.bankAccount.addAccountPopup.validationMessage.routingNumberRequired"
                                                    )}
                                                </span>
                                            )}
                                            {{ ...errors["routingNumber"] }.type === "pattern" && (
                                                <span aria-required="true" className="form-error">
                                                    {tLang(
                                                        "identityVault.monitoredInformation.financialAccountWidget.bankAccount.addAccountPopup.validationMessage.routingNumberPattern"
                                                    )}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                         */}</React.Fragment>
                        <div className="dialog-footer">
                            <div className="row between-xs">
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="button" id="btn-cancel-dark-web-add-financial-acc" className="btn-default btn-link btn-no-padding btn-no-border">
                                        <span className="btn-text">
                                            {tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.addAccountPopup.cancelButtonText")}
                                        </span>
                                    </button>
                                </div>
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="submit" className="btn-default btn-primary btn-min-width" disabled={isSubmitting}>
                                        <span className="btn-text">
                                            {tLang("identityVault.monitoredInformation.financialAccountWidget.bankAccount.addAccountPopup.saveButtonText")}
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </React.Fragment>
    );
};
export default DarkWebFinancialAccountAddBankDialog;
